module.exports = __webpack_public_path__ + "assets/img/bg.8ede78b2.png";